import { batchPrintStepsType } from "../../../../customTypes/batchPrintModal";

export function defineDataTestid(batchPrintSteps: batchPrintStepsType) {
    const id = batchPrintSteps.stepA_Confirm
        ? "dialog-step1-confirm-selection"
        : batchPrintSteps.stepB_PreparePdf
            ? "dialog-step2-preparing-pdf-document"
            : batchPrintSteps.stepC_DocumentReady
                ? "dialog-step2-pdf-document-ready"
                : batchPrintSteps.stepD_Confirm
                    ? "dialog-step3-confirm-documents-have-printed"
                    : batchPrintSteps.pdfGenError
                        ? "dialog-compilation-error"
                        : batchPrintSteps.docExpired
                            ? "dialog-pdf-document-expired"
                            : batchPrintSteps.cancelConfirmPrint || batchPrintSteps.cancelConfirmError
                                ? "dialog-cancel-confirmation"
                                : batchPrintSteps.confirmingPrintJobs
                                    ? "dialog-batch-print-confirmation"
                                    : ""

    return id;
}